import { type DocumentNode, gql } from '@apollo/client';

const updateCollectionSequence: DocumentNode = gql`
  mutation updateSeq($collectionId: ID!, $assetId: ID!, $sequence: Int!) {
    updateSequenceOnCollection(assetId: $assetId, collectionId: $collectionId, sequence: $sequence) {
      collection {
        id
        items(orderBy: "sequence") {
          totalCount
          edges {
            node {
              id
              sequence
              contentObject {
                ... on AssetNodeType {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default updateCollectionSequence;
